'use strict';

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _ReadHandlers;

var _require = require('buffer'),
    Buffer = _require.Buffer;

var BufferList = require('bl/BufferList');

var varintDecode = require('./varint-decode'); // Maximum length of the length section of the message


var MAX_LENGTH_LENGTH = 8; // Varint.encode(Number.MAX_SAFE_INTEGER).length
// Maximum length of the data section of the message

var MAX_DATA_LENGTH = 1024 * 1024 * 4;
var Empty = Buffer.alloc(0);
var ReadModes = {
  LENGTH: 'readLength',
  DATA: 'readData'
};
var ReadHandlers = (_ReadHandlers = {}, _defineProperty(_ReadHandlers, ReadModes.LENGTH, function (chunk, buffer, state, options) {
  // console.log(ReadModes.LENGTH, chunk.length)
  buffer = buffer.append(chunk);
  var dataLength;

  try {
    dataLength = options.lengthDecoder(buffer);
  } catch (err) {
    if (buffer.length > options.maxLengthLength) {
      throw Object.assign(err, {
        message: 'message length too long',
        code: 'ERR_MSG_LENGTH_TOO_LONG'
      });
    }

    if (err instanceof RangeError) {
      return {
        mode: ReadModes.LENGTH,
        buffer: buffer
      };
    }

    throw err;
  }

  if (dataLength > options.maxDataLength) {
    throw Object.assign(new Error('message data too long'), {
      code: 'ERR_MSG_DATA_TOO_LONG'
    });
  }

  chunk = buffer.shallowSlice(options.lengthDecoder.bytes);
  buffer = new BufferList();
  if (options.onLength) options.onLength(dataLength);

  if (dataLength <= 0) {
    if (options.onData) options.onData(Empty);
    return {
      mode: ReadModes.LENGTH,
      chunk: chunk,
      buffer: buffer,
      data: Empty
    };
  }

  return {
    mode: ReadModes.DATA,
    chunk: chunk,
    buffer: buffer,
    state: {
      dataLength: dataLength
    }
  };
}), _defineProperty(_ReadHandlers, ReadModes.DATA, function (chunk, buffer, state, options) {
  // console.log(ReadModes.DATA, chunk.length)
  buffer = buffer.append(chunk);

  if (buffer.length < state.dataLength) {
    return {
      mode: ReadModes.DATA,
      buffer: buffer,
      state: state
    };
  }

  var dataLength = state.dataLength;
  var data = buffer.shallowSlice(0, dataLength);
  chunk = buffer.length > dataLength ? buffer.shallowSlice(dataLength) : null;
  buffer = new BufferList();
  if (options.onData) options.onData(data);
  return {
    mode: ReadModes.LENGTH,
    chunk: chunk,
    buffer: buffer,
    data: data
  };
}), _ReadHandlers);

function decode(options) {
  options = options || {};
  options.lengthDecoder = options.lengthDecoder || varintDecode;
  options.maxLengthLength = options.maxLengthLength || MAX_LENGTH_LENGTH;
  options.maxDataLength = options.maxDataLength || MAX_DATA_LENGTH;
  return function (source) {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var buffer, mode, state, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              buffer = new BufferList();
              mode = ReadModes.LENGTH; // current parsing mode

              // accumulated state for the current mode
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 4;
              _iterator = _asyncIterator(source);

            case 6:
              _context.next = 8;
              return _awaitAsyncGenerator(_iterator.next());

            case 8:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 12;
              return _awaitAsyncGenerator(_step.value);

            case 12:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 29;
                break;
              }

              chunk = _value;

            case 15:
              if (!chunk) {
                _context.next = 26;
                break;
              }

              result = ReadHandlers[mode](chunk, buffer, state, options);
              mode = result.mode;
              chunk = result.chunk;
              buffer = result.buffer;
              state = result.state;

              if (!result.data) {
                _context.next = 24;
                break;
              }

              _context.next = 24;
              return result.data;

            case 24:
              _context.next = 15;
              break;

            case 26:
              _iteratorNormalCompletion = true;
              _context.next = 6;
              break;

            case 29:
              _context.next = 35;
              break;

            case 31:
              _context.prev = 31;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 35:
              _context.prev = 35;
              _context.prev = 36;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 40;
                break;
              }

              _context.next = 40;
              return _awaitAsyncGenerator(_iterator.return());

            case 40:
              _context.prev = 40;

              if (!_didIteratorError) {
                _context.next = 43;
                break;
              }

              throw _iteratorError;

            case 43:
              return _context.finish(40);

            case 44:
              return _context.finish(35);

            case 45:
              if (!buffer.length) {
                _context.next = 47;
                break;
              }

              throw Object.assign(new Error('unexpected end of input'), {
                code: 'ERR_UNEXPECTED_EOF'
              });

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 31, 35, 45], [36,, 40, 44]]);
    }))();
  };
}

decode.fromReader = function (reader, options) {
  var _varByteSource;

  options = options || {};
  var byteLength = 1; // Read single byte chunks until the length is known

  var varByteSource = (_varByteSource = {}, _defineProperty(_varByteSource, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_varByteSource, "next", function () {
    var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return reader.next(byteLength);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0.code === 'ERR_UNDER_READ')) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return", {
                done: true,
                value: null
              });

            case 10:
              throw _context2.t0;

            case 11:
              _context2.prev = 11;
              // Reset the byteLength so we continue to check for varints
              byteLength = 1;
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6, 11, 14]]);
    }));

    function next() {
      return _next.apply(this, arguments);
    }

    return next;
  }()), _varByteSource); // Once the length has been parsed, read chunk for that length

  options.onLength = function (l) {
    byteLength = l;
  };

  return decode(options)(varByteSource);
};

module.exports = decode;
module.exports.MAX_LENGTH_LENGTH = MAX_LENGTH_LENGTH;
module.exports.MAX_DATA_LENGTH = MAX_DATA_LENGTH;